import { render } from "./StepSubpageHome.vue?vue&type=template&id=3c4d240e&scoped=true&bindings={}"
import script from "./StepSubpageHome.vue?vue&type=script&lang=ts"
export * from "./StepSubpageHome.vue?vue&type=script&lang=ts"

import "./StepSubpageHome.vue?vue&type=style&index=0&id=3c4d240e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c4d240e"

export default script